import createIcon from '../../createIcon';

/**
 * @component @name Train
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMi41QzggMi41IDQgMyA0IDYuNVYxNkM0IDE3LjkzIDUuNTcgMTkuNSA3LjUgMTkuNUw2IDIxVjIxLjVIOC4yM0wxMC4yMyAxOS41SDE0TDE2IDIxLjVIMThWMjFMMTYuNSAxOS41QzE4LjQzIDE5LjUgMjAgMTcuOTMgMjAgMTZWNi41QzIwIDMgMTYuNDIgMi41IDEyIDIuNVpNNy41IDE3LjVDNi42NyAxNy41IDYgMTYuODMgNiAxNkM2IDE1LjE3IDYuNjcgMTQuNSA3LjUgMTQuNUM4LjMzIDE0LjUgOSAxNS4xNyA5IDE2QzkgMTYuODMgOC4zMyAxNy41IDcuNSAxNy41Wk0xMSAxMC41SDZWNi41SDExVjEwLjVaTTEzIDEwLjVWNi41SDE4VjEwLjVIMTNaTTE2LjUgMTcuNUMxNS42NyAxNy41IDE1IDE2LjgzIDE1IDE2QzE1IDE1LjE3IDE1LjY3IDE0LjUgMTYuNSAxNC41QzE3LjMzIDE0LjUgMTggMTUuMTcgMTggMTZDMTggMTYuODMgMTcuMzMgMTcuNSAxNi41IDE3LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Train = createIcon('Train', [
  [
    'path',
    {
      d: 'M12 2.5C8 2.5 4 3 4 6.5V16C4 17.93 5.57 19.5 7.5 19.5L6 21V21.5H8.23L10.23 19.5H14L16 21.5H18V21L16.5 19.5C18.43 19.5 20 17.93 20 16V6.5C20 3 16.42 2.5 12 2.5ZM7.5 17.5C6.67 17.5 6 16.83 6 16C6 15.17 6.67 14.5 7.5 14.5C8.33 14.5 9 15.17 9 16C9 16.83 8.33 17.5 7.5 17.5ZM11 10.5H6V6.5H11V10.5ZM13 10.5V6.5H18V10.5H13ZM16.5 17.5C15.67 17.5 15 16.83 15 16C15 15.17 15.67 14.5 16.5 14.5C17.33 14.5 18 15.17 18 16C18 16.83 17.33 17.5 16.5 17.5Z',
      key: 'dsfuy1',
    },
  ],
]);

export default Train;
